export const SKILL_CATEGORY_LABELS = {
  skill: 'Savoir-faire', tool: 'Logiciels et outils', knowledge: 'Connaissances', sector: 'Expériences sectorielles',
  technical_skill: 'Compétence technique',
  methodology: 'Méthodologie',
  standard_regulation: 'Norme et réglementation',
  project_management: 'Gestion de projet',
  soft_skill: 'Compétence comportementale',
  sector_knowledge: 'Connaissance sectorielle',
  other: 'Autre',
};

export const getSkillCategoryLabel = (category) => SKILL_CATEGORY_LABELS[category] || category || 'Autre';
